import { render, staticRenderFns } from "./legendBari.vue?vue&type=template&id=19a746bc"
import script from "./legendBari.vue?vue&type=script&lang=js"
export * from "./legendBari.vue?vue&type=script&lang=js"
import style0 from "./legendBari.vue?vue&type=style&index=0&id=19a746bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports